"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioDirection = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Radio_1 = __importDefault(require("./Radio"));
var RadioDirection;
(function (RadioDirection) {
    RadioDirection[RadioDirection["VERTICAL"] = 0] = "VERTICAL";
    RadioDirection[RadioDirection["HORIZONTAL"] = 1] = "HORIZONTAL";
})(RadioDirection = exports.RadioDirection || (exports.RadioDirection = {}));
var RadioGroup = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, className = _a.className, disabled = _a.disabled, direction = _a.direction;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-radio-group", disabled && 'disabled', direction === RadioDirection.HORIZONTAL && 'ui-radio-group-horizontal', className) }, options.map(function (o, i) { return (react_1.default.createElement("div", { key: o.divider ? "divider-".concat(i) : o.value }, o.divider ? (react_1.default.createElement("hr", { className: "ui-radio-group-divider" })) : (react_1.default.createElement(Radio_1.default, { label: o.label, checked: value === o.value, onClick: function () { return onChange(o, o.value); }, disabled: disabled || o.disabled })))); })));
};
exports.default = RadioGroup;
